var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27495_9598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41895 2.33203H2.33561C2.02619 2.33203 1.72945 2.45495 1.51065 2.67374C1.29186 2.89253 1.16895 3.18928 1.16895 3.4987V11.6654C1.16895 11.9748 1.29186 12.2715 1.51065 12.4903C1.72945 12.7091 2.02619 12.832 2.33561 12.832H10.5023C10.8117 12.832 11.1084 12.7091 11.3272 12.4903C11.546 12.2715 11.6689 11.9748 11.6689 11.6654V7.58203",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7939 1.45619C11.026 1.22412 11.3408 1.09375 11.6689 1.09375C11.9971 1.09375 12.3119 1.22412 12.5439 1.45619C12.776 1.68825 12.9064 2.003 12.9064 2.33119C12.9064 2.65938 12.776 2.97412 12.5439 3.20619L7.00228 8.74785L4.66895 9.33119L5.25228 6.99785L10.7939 1.45619Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27495_9598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.cbf9283a179b8b57e5b9c943e9380953.svg";
export { ForwardRef as ReactComponent };